import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于6080影院，您可能想了解的问题都在这里
        </p>
        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-lg border border-background-300/40 bg-background-100/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.question}
                </h3>
                <div className={`w-5 h-5 flex items-center justify-center shrink-0 transition-transform duration-200 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-400"></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}